import { Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import UVPrintingImage from '../Images/UVPrinting.jpg';
import ScreenPrintingImage from '../Images/ScreenPrinting.jpg';
import HotStampPrintingImage from '../Images/HotStampPrinting.jpg';
import ThermalDecalPrintingImage from '../Images/ThermalDecalPrinting.jpg'

const theme = createTheme({
    palette: {
        primary: {
            main: "#F61832", // custom primary color
        },
        secondary: {
            main: "#C13E39", // custom secondary color
        },
    },
});

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


 const ServiceImages = {
    "Hot Stamp Printing": HotStampPrintingImage,
    "UV Printing": UVPrintingImage,
    "Screen Printing" : ScreenPrintingImage,
    "Thermal Decal Printing": ThermalDecalPrintingImage,
    
  };

  useEffect(() => {
    const loadServices = async () => {
      try {
        // Load services from Services.json in public folder
        const response = await fetch('/Services.json');
        
        if (!response.ok) {
          throw new Error('Failed to load services');
        }
        
        const data = await response.json();
        setServices(data);
        setLoading(false);
      } catch (err) {
        console.error('Error loading services:', err);
        setError('Failed to load services');
        setLoading(false);
      }
    };

    loadServices();
  }, []);

 const handleServiceClick = (serviceLink) => {
    window.location.href = serviceLink;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center">
        <div className=" text-2xl font-semibold">Loading Services...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center">
        <div className="text-red-300 text-2xl font-semibold">{error}</div>
      </div>
    );
  }

  return (
    <div className="max-w-[1200px] mx-auto px-8 pt-8">
      <title>Thermal Decal Printing, Hot Stamp Printing, Screen Printing, UV Printing</title>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Our Services
          </h1>
          <p className="text-xl max-w-2xl mx-auto">
            Discover our comprehensive range of professional services
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-1 xl:grid-cols-2 gap-8">
          {services.map((service) => (
            <div
              key={service.ID}
              className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-white/15 hover:-translate-y-2 hover:shadow-2xl cursor-pointer group"
              onClick={() => handleServiceClick(service.ServiceLink)}
            >
              {/* Service Image */}
              <div className="relative overflow-hidden">
                <img
                  src={ServiceImages[service.ServiceName]}
                  alt={service.ServiceName}
                  className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
              </div>

              {/* Service Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold  mb-3">
                  {service.ServiceName}
                </h3>
                <p className="leading-relaxed mb-6">
                  {service.ServiceDescription}
                </p>

                {/* Learn More Button */}
                 <ThemeProvider theme={theme}>
                <Button  onClick={(e) => {
                    e.stopPropagation();
                    handleServiceClick(service.ServiceLink);
                  }}
                  color='primary'
                  variant='contained'
                  >Learn More</Button>
               </ThemeProvider>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {services.length === 0 && !loading && !error && (
          <div className="text-center  text-xl">
            No services available at the moment.
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;